// Data hooks of the partner directory: the search is read page by page ("Afficher plus").
import {
  directoryControllerSearch,
  type DirectoryControllerSearchParams,
  type DirectoryPageDtoOutput,
} from '@batiflow/api-client';
import { useInfiniteQuery } from '@tanstack/react-query';

export const DIRECTORY_PAGE_SIZE = 20;

export type DirectoryFilters = Pick<
  DirectoryControllerSearchParams,
  'discipline' | 'governorate' | 'q'
>;

/** The offices that opted in, filtered; `cursor` pages follow `nextCursor`. */
export function useDirectorySearch(filters: DirectoryFilters) {
  return useInfiniteQuery({
    queryKey: ['/api/v1/directory', 'pages', filters],
    queryFn: ({ pageParam, signal }): Promise<DirectoryPageDtoOutput> =>
      directoryControllerSearch(
        { ...filters, limit: DIRECTORY_PAGE_SIZE, ...(pageParam ? { cursor: pageParam } : {}) },
        signal,
      ),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (page) => page.nextCursor ?? undefined,
    retry: false,
  });
}
